@if (pictureTag) {
  <picture>
    @for (source of pictureTag.sources; track $index) {
      <source
        [media]="source.mediaQuery"
        [xCloudImage]="source.url"
        [width]="source.dimensions.width"
        [height]="source.dimensions.height"
        quality="auto:best"
        crop="fill"
        srcset=""
      />
    }
    <img
      [xCloudImage]="pictureTag.default.url"
      [width]="pictureTag.default.dimensions.width"
      [height]="pictureTag.default.dimensions.height"
      crop="fill"
      quality="auto:best"
      alt=""
      src=""
    />
  </picture>
}
